
import { FilterPersistence } from '../../api/filter/filter_persistence';
import {
  MaintenanceIndex,
  MaintenanceIndexFilters,
  MaintenanceIndexOptions,
} from '../../api/maintenances/maintenance_index';
import { Maintenance } from '../../api/maintenances/maintenance';
import { formatDate, parseDate } from '../../api/dates/date_formatter';

import Vue from 'vue';

export default Vue.component('maintenance-index', {
  props: ['courseId'],
  data() {
    return {
      fieldFilters: {} as MaintenanceIndexFilters,
      startFilter: '',
      startFilterFormatted: '',
      endFilter: '',
      endFilterFormatted: '',
      courseFilter: '',
      descFilter: '',
      headers: [
        { text: 'Start', value: 'start_date' },
        { text: 'End', value: 'end_date' },
        { text: 'Course', value: 'course.course_name' },
        { text: 'Description', value: 'description' },
        { text: 'View', value: 'view' },
      ],
      loading: true,
      loadingText: 'Loading Data...',
      maintCount: -1,
      maintenances: [] as Maintenance[],
      options: {} as MaintenanceIndexOptions,
      perPage: MaintenanceIndex.PER_PAGE,
      pageNo: 1 as number,
      showFilters: true as boolean,
      sortDesc: [] as boolean[],
      sortBy: [] as string[],
    };
  },
  mounted() {
    this.loadFilters();
    // We call this after loadFilters since some field filters are provided as props.
    this.updateFilters();
    this.refreshTable();
  },
  methods: {
    parseDateInternal(date: string): string {
      return parseDate(date);
    },
    refreshTable() {
      if (this.courseId) {
        this.showFilters = false;
      }
      this.options.sortDesc = this.sortDesc;
      this.options.sortBy = this.sortBy;
      this.options.page = this.pageNo;
      this.options.itemsPerPage = this.perPage;
      this.options.filters = this.fieldFilters;
      MaintenanceIndex.getData(this.options).then((response) => {
        this.maintenances = MaintenanceIndex.parseResponse(response.data);
        this.loading = false;
      });
      MaintenanceIndex.getCount(this.fieldFilters).then((response) => {
        this.maintCount = response.data;
      });
    },
    search() {
      this.pageNo = 1;
      this.refreshTable();
    },
    maybeSearch(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        this.updateFilters();
        FilterPersistence.saveFieldFilterState(
          this.$router,
          'manage-maintenances',
          this.fieldFilters,
        );
        this.search();
      }
    },
    loadFilters() {
      const filter = FilterPersistence.getFieldFiltersFromUrl(this.$route);
      if (!filter) {
        return;
      }
      this.fieldFilters = filter;

      this.courseFilter = this.fieldFilters.course_name;
      this.startFilter = this.fieldFilters.start_date;
      this.endFilter = this.fieldFilters.end_date;
      this.descFilter = this.fieldFilters.description;
    },
    updateFilters() {
      this.fieldFilters = {
        course_id: this.courseId,
        course_name: this.courseFilter,
        start_date: this.startFilter,
        end_date: this.endFilter,
        description: this.descFilter,
      };
    },
  },
  watch: {
    endFilter: {
      handler() {
        this.endFilterFormatted = formatDate(this.endFilter);
        const e = this.$refs.endDate as HTMLElement;
        e.focus();
      },
    },
    startFilter: {
      handler() {
        this.startFilterFormatted = formatDate(this.startFilter);
        const e = this.$refs.startDate as HTMLElement;
        e.focus();
      },
    },
    pageNo: {
      handler() {
        this.refreshTable();
      },
    },
    perPage: {
      handler() {
        this.refreshTable();
      },
    },
    sortDesc: {
      handler() {
        this.refreshTable();
      },
    },
  },
});
